import React, { useState, useEffect } from 'react';
import Axios from 'axios';

import * as Antd from 'antd';
import * as AntdIcons from '@ant-design/icons';
import * as SYS from './';

export const ConnectorsGrid = props => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [connectorFormInit, setConnectorFormInit] = useState(null);

    const fetchData = async () => {
        try {
            let dataResponse = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/connectors`);
            return dataResponse.data;
        } catch (err) {
            console.log(err);
        }
    }

    const init = async () => {
        setLoading(true);
        let d = await fetchData();
        setData(d);
        setLoading(false);
    }

    const onFormSuccess = async (values) => {
        try {
            if (values.id) {
                let id = values.id;
                delete values.id;
                await Axios.patch(`${process.env.REACT_APP_API_BASE_URI}/api/connectors/${id}`, values);
            } else {
                await Axios.post(`${process.env.REACT_APP_API_BASE_URI}/api/connectors`, values);
            }
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    const onDeleteItem = async (id) => {
        try {
            await Axios.delete(`${process.env.REACT_APP_API_BASE_URI}/api/connectors/${id}`);
            await init();
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        init();
    }, []);

    return (
        <>
            <Antd.Space
                style={{
                    marginBottom: 10,
                    float: 'right',
                }}
            >
                {/* <Antd.Button
                    icon={<AntdIcons.DownloadOutlined />}
                    title="Export"
                    disabled={loading}                    
                    // onClick={() => {
                    //     setConnectorFormInit({});
                    // }}
                /> */}
                <Antd.Button
                    icon={<AntdIcons.ReloadOutlined />}
                    title="Reload"
                    disabled={loading}
                    onClick={() => {
                        init();
                    }}
                />
                <Antd.Button
                    icon={<AntdIcons.PlusOutlined />}
                    title="Create new"
                    disabled={loading}
                    onClick={() => {
                        setConnectorFormInit({});
                    }}
                />
            </Antd.Space>
            <Antd.Table
                className="table-striped-rows table-small"
                size={'small'}
                loading={loading}
                rowKey={'id'}
                pagination={{
                    defaultPageSize: 50,                    
                    showSizeChanger: true,
                }}
                columns={[{
                    key: 'code',
                    dataIndex: 'code',
                    title: 'Code',
                    width: 250,
                }, {
                    key: 'name',
                    dataIndex: 'name',
                    title: 'Name',
                }, {
                    key: 'type',
                    dataIndex: 'type',
                    title: 'Type',
                }, {
                    key: 'driver',
                    dataIndex: 'driver',
                    title: 'Driver',
                }, {
                    key: 'debugMode',
                    dataIndex: 'debugMode',
                    title: 'Debug mode',
                    render: val => (
                        <Antd.Tag
                            color={val === true ? 'green' : 'volcano'}
                            key={val}
                        >
                            {val === true ? 'YES' : 'NO'}
                        </Antd.Tag>
                    )
                }, {
                    key: 'action',
                    title: 'Action',
                    width: 200,
                    render: (text, record) => (
                        <Antd.Space
                            size="middle"
                        >
                            <a
                                onClick={() => {
                                    record.parametersArr = [];
                                    for (let pk in record.parameters) {
                                        record.parametersArr.push({ key: pk, value: record.parameters[pk] })
                                    }
                                    setConnectorFormInit(record);
                                }}
                            >
                                Edit
                            </a>
                            <a
                                onClick={() => {
                                    delete record.id;
                                    record.code = record.code + 'Copy';
                                    record.name = record.name + ' - copy';
                                    onFormSuccess(record);
                                }}
                            >
                                Copy
                            </a>
                            <Antd.Popconfirm
                                placement="topLeft"
                                title="Do you really want to delete the entry?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => {
                                    onDeleteItem(record.id);
                                }}
                            >
                                <a>
                                    Delete
                                </a>
                            </Antd.Popconfirm>
                        </Antd.Space>
                    )
                }]}
                dataSource={data}
            />
            <Antd.Drawer
                title={connectorFormInit && connectorFormInit.id
                    ? 'Edit connector'
                    : 'Create new connector'}
                width={1000}
                visible={connectorFormInit !== null
                    ? true
                    : false}
                closable={true}
                onClose={() => setConnectorFormInit(null)}
            >
                {connectorFormInit
                    ? <SYS.ConnectorForm
                        initialValues={connectorFormInit}
                        onSuccess={onFormSuccess}
                    />
                    : null}
            </Antd.Drawer>
        </>
    )
}